import { DataTableSortStatus } from "mantine-datatable"
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "@/shared"
import { DeliveryStop } from "../domain/delivery-stop.types"
import { ScheduledPreset } from "../utils/scheduled-presets"

export interface DeliveryStopSearchState {
  riderId: string
  scheduledDate: Date | null
  /** Acceso rápido de fecha programada (hoy, mañana, este mes); excluye a `scheduledDate` */
  scheduledPreset: ScheduledPreset | null
  action: string
  status: string
  search: string
  /** En curso (por defecto: sin los finalizados) | Finalizados (solo los completados) | Todos */
  vista: "en_curso" | "finalizados" | "todos"
  /** "Perú" | "Ecuador" | "" (los dos). Solo lo usa el admin: al resto el back le recorta su país */
  country: string
}

export interface DeliveryStopState {
  search: DeliveryStopSearchState
  page: number
  rows: number
  sortStatus: DataTableSortStatus<DeliveryStop>
}

export type DeliveryStopAction =
  | { type: "SET_SEARCH"; payload: Partial<DeliveryStopSearchState> }
  | { type: "SET_PAGE"; payload: number }
  | { type: "SET_ROWS"; payload: number }
  | { type: "SET_SORT"; payload: DataTableSortStatus<DeliveryStop> }

export const deliveryStopInitialState: DeliveryStopState = {
  search: { riderId: "", scheduledDate: null, scheduledPreset: null, action: "", status: "", search: "", vista: "en_curso", country: "" },
  page: DEFAULT_PAGE,
  rows: DEFAULT_PAGE_SIZE,
  sortStatus: { columnAccessor: "createdAt", direction: "desc" }
}

export function deliveryStopReducer(state: DeliveryStopState, action: DeliveryStopAction): DeliveryStopState {
  switch (action.type) {
    case "SET_SEARCH":
      return { ...state, search: { ...state.search, ...action.payload }, page: 1 }
    case "SET_PAGE":
      return { ...state, page: action.payload }
    case "SET_ROWS":
      return { ...state, rows: action.payload, page: 1 }
    case "SET_SORT":
      return { ...state, sortStatus: action.payload }
    default:
      return state
  }
}
